<template>
  <span v-show="post.totalFaces && isGranted('VIEW_PERSONS')">
    <q-btn
      icon="fa fa-users"
      title="Faces"
      v-bind="$attrs"
      @click="openSidebar"
    >
      <q-badge
        :label="post.totalFaces"
        color="primary"
        floating
        style="top: -1px"
      />
    </q-btn>
    <FaceDetailDialog
      ref="faceDetail"
      :client-id="post.client.id"
      @view-person="openPerson"
    />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import { Face } from '@/analysis/types';
import isGranted from '@/auth/isGranted';
import { openDrawer } from '@/layout';
import openModal from '@/components/modal';
import FaceDetailDialog from '@/analysis/face/FaceDetailDialog.vue';
import PostFacesSidebar from './PostFacesSidebar.vue';

export default defineComponent({
  components: {
    FaceDetailDialog,
  },
  props: {
    post: {
      type: Object as () => Post,
      required: true,
    },
  },
  methods: {
    isGranted,
    openSidebar() {
      openDrawer({
        component: PostFacesSidebar,
        props: {
          clientId: this.post.client.id,
          postId: this.post.id,
        },
        on: {
          'face-click': this.onFaceClick,
        },
        paddless: true,
        closable: false,
      });
    },
    onFaceClick(face: Face) {
      (this.$refs.faceDetail as any).open(face);
    },
    async openPerson(person: any, callback: () => void) {
      const { default: PersonDetailDialog } = await import('@/analysis/person/PersonDetailDialog.vue');
      openModal(PersonDetailDialog, {
        parent: this,
        clientId: this.post.client.id,
        person,
      });
      callback();
    },
  },
});
</script>
